(() => {
  function initialise(form) {
    if (form.dataset.contactReady) return;
    const email = form.querySelector('[data-contact-email]');
    const phone = form.querySelector('[data-contact-phone]');
    if (!email || !phone) return;
    const settings = form.querySelector('[data-infinote-contact-settings]');
    if (!settings) return;
    form.dataset.contactReady = 'true';
    const transport = document.createElement('input');
    transport.type = 'email';
    transport.hidden = true;
    transport.name = 'contact[email]';
    const reply = document.createElement('input');
    reply.type = 'hidden';
    reply.name = 'contact[Reply via]';
    email.name = 'contact[Customer email]';
    email.required = false;
    form.append(transport, reply);

    function validate() {
      const address = email.value.trim();
      const number = phone.value.trim();
      email.setCustomValidity(!address && !number ? settings.dataset.contactMissing : '');
      phone.setCustomValidity(number && (!/^[+()\d\s\-]+$/.test(number) || !/\d/.test(number)) ? settings.dataset.contactPhoneInvalid : '');
      transport.value = address || (number ? 'phone-only+' + number.replace(/\D/g, '') + '@example.invalid' : '');
      reply.value = address ? 'Email' : 'Phone — no customer email provided';
    }

    [email, phone].forEach((field) => field.addEventListener('input', validate));
    form.addEventListener('submit', (event) => {
      validate();
      if (!form.reportValidity()) event.preventDefault();
    });
    form.addEventListener('reset', () => setTimeout(validate, 0));
    window.addEventListener('pageshow', validate);
    validate();
  }

  function initialiseForms(root) {
    root.querySelectorAll('[data-infinote-contact-settings]').forEach((settings) => initialise(settings.closest('form')));
  }
  initialiseForms(document);
  document.addEventListener('shopify:section:load', (event) => initialiseForms(event.target));
})();
